/**
 * FieldLabel — small secondary label used for form fields under a SectionLabel.
 */

import type { CSSProperties, ReactNode } from "react";
import { SECONDARY } from "@/styles/design-tokens";

interface FieldLabelProps {
  children: ReactNode;
  style?: CSSProperties;
}

export function FieldLabel({ children, style }: FieldLabelProps) {
  return (
    <span
      style={{
        fontSize: 12,
        color: SECONDARY,
        display: "block",
        marginBottom: 6,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
